import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../../common/html/checkbox'
import { Element } from '../../../../common/html/element'
import { getUnique } from '../../../../helpers/common'
import { MAX_ADDITIONAL_INFO } from '../../common/constant'
import { changeViews, selectViews, selectViewsCount } from '../store/slice'
import {
  changeAlertPopup,
  selectScreeningIndicatorById,
  selectYearReports,
} from './../../common/store/slice'
import { FiscalYear } from './FiscalYear'
import classes from './index.module.scss'

export const IndicatorItem = ({ item, index }) => {
  const dispatch = useDispatch()

  const [isHovered, setIsHovered] = useState(false)

  const screeningIndicatorById = useSelector(selectScreeningIndicatorById())
  const yearReports = useSelector(selectYearReports)

  const viewsData = useSelector(selectViews)
  const viewsCount = useSelector(selectViewsCount)

  const selectedData = viewsData.find(
    (view) => view.screeningIndicatorId === item.screeningIndicatorId,
  )

  const selectedYears = viewsData
    .filter((view) => view.screeningIndicatorId === item.screeningIndicatorId)
    .map((view) => view.year)

  const screeningIndicatorIdsUpdate = Object.values(screeningIndicatorById)
    .filter(
      (indicator) =>
        indicator.fsTypeCode === item.fsTypeCode &&
        indicator.screeningIndicatorName === item.screeningIndicatorName,
    )
    .map((i) => i.screeningIndicatorId)

  const checkMaxAdditionalInfo = () => {
    if (viewsCount >= MAX_ADDITIONAL_INFO) {
      dispatch(
        changeAlertPopup({
          isShow: true,
          title: 'screening.WARNING',
          message: 'screening.MAX_ADDITIONAL_INFO_MESS',
          translateProps: { max: MAX_ADDITIONAL_INFO },
        }),
      )
      return true
    }
  }

  const handleSelect = (checked) => {
    if (checked) {
      if (checkMaxAdditionalInfo()) return

      const groupId = getUnique()
      dispatch(
        changeViews([
          ...viewsData,
          ...screeningIndicatorIdsUpdate.map((id) => ({
            screeningIndicatorId: id,
            year: yearReports[0],
            groupId,
          })),
        ]),
      )
    } else {
      dispatch(
        changeViews(
          viewsData.filter(
            ({ screeningIndicatorId }) =>
              !screeningIndicatorIdsUpdate.includes(screeningIndicatorId),
          ),
        ),
      )
    }
  }

  const onChangeYear = (checked, year) => {
    let newViewsData = [...viewsData]
    if (checked) {
      if (checkMaxAdditionalInfo()) return
      const groupId = getUnique()
      screeningIndicatorIdsUpdate.forEach((id) => {
        newViewsData.push({ screeningIndicatorId: id, year, groupId })
      })
    } else {
      newViewsData = newViewsData.filter(
        (view) =>
          !(
            screeningIndicatorIdsUpdate.includes(view.screeningIndicatorId) &&
            view.year === year
          ),
      )
    }
    dispatch(changeViews(newViewsData))
    if (
      !newViewsData.find(
        (view) => view.screeningIndicatorId === item.screeningIndicatorId,
      )
    ) {
      setIsHovered(false)
    }
  }

  const handleClickRow = () => {
    handleSelect(!selectedData)
  }

  const onMouseOver = () => {
    setIsHovered(true)
  }

  const onMouseLeave = () => {
    setIsHovered(false)
  }

  return (
    <Element
      className={classes.row}
      style={{
        backgroundColor: isHovered ? '#EDF5FE' : index % 2 ? '' : '#F9F9F9',
      }}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      onClick={handleClickRow}
    >
      <Checkbox
        title={item.screeningIndicatorName}
        isCheckOnClickText
        checked={!!selectedData}
        onChange={handleSelect}
      />

      {!!selectedData && (
        <FiscalYear selectedYears={selectedYears} onChangeYear={onChangeYear} />
      )}
    </Element>
  )
}
